import React from 'react';
import { Link } from 'react-router-dom';
import classnames from 'classnames';
import { isEmpty, } from 'lodash';

import env from '../env';

const navItems = [
  {
    path: _ => '/',
    label: 'ダッシュボード',
    regExp: /^\/$/,
  },
  {
    path: _ => _.user?.preferences?.productsTab || '/products',
    label: '商品/在庫マスタ',
    regExp: /^(products|amazonProducts)/,
  },
  {
    path: _ => '/receivingRequests',
    label: '入荷',
  },
  {
    path: _ => '/shippingRequests',
    label: '出荷',
  },
  {
    path: _ => '/mallOrders',
    label: '受注',
    visible: _ => _.tenant?.tenantOptionValues?.join('').match(/rakuten|shopify|yahoo|tts|qoo10/),
  },
  {
    path: _ => '/combiningRequests',
    label: '加工',
  },
  {
    path: _ => '/batchImports',
    label: 'CSV一括処理',
  },
  {
    path: _ => '/macros',
    label: 'マクロ',
  },
  {
    path: _ => '/settings',
    label: '設定',
  },
  {
    path: _ => '/useCounts',
    label: '利用状況',
  },
];

export default function SideNav (props) {
  const { className, location, style, ...extraProps } = props;

  return (
    <div className={classnames('position-fixed px-2 py-3 side-nav bg-white', className)} style={{ zIndex: 1000, bottom: 0, ...style }} {...extraProps}>
      <ul className="h-100 nav nav-pills flex-column">
        {
          navItems.filter(_ => !_.visible || _.visible(props)).map(({ path, label, regExp, }) => {
            return (
              <li className="nav-item" key={label}>
                <Link to={path(props)} className={classnames('nav-link', { active: location.pathname.match(regExp || path(props)) })}>
                  {label}
                </Link>
              </li>
            );
          })
        }
        {
          !isEmpty(env('HELP_URL')) && (
            <li className="nav-item">
              <a href={env('HELP_URL')} className="nav-link" target="_blank">
                ご利用ガイド
                <span className="fas fa-external-link-alt ml-1" />
              </a>
            </li>
          )
        }
      </ul>
    </div>
  );
};
